import {SponsorTypeEnum} from 'modules/coupons/types';
import {PermissionGroupProps} from 'modules/permission-groups/types';
import permissionGroupsKeys from 'modules/permission-groups/util/permission-groups-keys';
import React from 'react';
import StatusButton from 'shared/components/status-button';
import List from 'shared/layout/list';
import useProjection from 'shared/migration-hooks/use-projection';

const PermissionGroups: React.FC = () => {
  const projection = useProjection<PermissionGroupProps>('permissionGroups', [
    'name',
    'type',
  ]);

  return (
    <List<PermissionGroupProps>
      titleBar={{
        title: 'Grupo de permissões',
        actionButton: {to: 'create', title: 'NOVO GRUPO DE PERMISSÕES'},
      }}
      table={{
        url: '/permission-groups',
        translatedPropsKey: 'PermissionGroupProps',
        projection: {
          ...projection,
          options: [
            'name',
            {
              value: 'type',
              column: (row) => (
                <StatusButton
                  text={
                    row.type === SponsorTypeEnum.COMPANY
                      ? 'Empresa'
                      : row.type === SponsorTypeEnum.CITY
                      ? 'Cidade'
                      : 'Franquia'
                  }
                  variant={
                    row.type === SponsorTypeEnum.COMPANY
                      ? 'warn'
                      : row.type === SponsorTypeEnum.CITY
                      ? 'info'
                      : 'error'
                  }
                />
              ),
            },
          ],
        },
      }}
      queryKey={permissionGroupsKeys.list()}
    />
  );
};

export default PermissionGroups;
